module.exports = "/lucky-balls/img/bigball/BigBall_017.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_017.png
// module id = 912
// module chunks = 0